import axios from 'axios';
import { getEnvUrl } from '../helpers/getEnvUrl';

export const getContentType = () => ({ 'Content-Type': 'application/json' });

const { apiBaseUrl } = getEnvUrl();

export const instance = axios.create({
    baseURL: apiBaseUrl,
    headers: getContentType(),
});

export default instance;
